import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ee2533e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ondergetekende verklaren hierbij, dat het hierna genoemde object, heden is opgeleverd.", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Aan de woning zijn de volgende onvolkomenheden geconstateerd:", -1))
const _hoisted_3 = {
  key: 0,
  class: "room-name"
}
const _hoisted_4 = { class: "issue" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["src"]
const _hoisted_7 = { style: {"margin-top":"16px"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Opleverfunctionaris", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = ["src"]
const _hoisted_12 = { style: {"margin-top":"16px"} }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Koper", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Let op!", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "no-mb" }, "De sleutels mogen niet worden overgedragen omdat de laatste termijnfactuur nog niet is voldaan.", -1))

import { deliveryStore } from '@/stores/delivery'
import { computed, ref } from 'vue'
import DeliveryDetailsRow from '@/components/delivery/DeliveryDetailsRow.vue'
import DeliveryContractorsRow from '@/components/delivery/DeliveryContractorsRow.vue'
import DeliveryEntityRow from '@/components/delivery/DeliveryEntityRow.vue'
import SignatureField from '@/components/SignatureField.vue'
import { KAMFormStatuses } from '@/helpers/kamFormStates'
import kamStore from '@/stores/kam'


export default /*#__PURE__*/_defineComponent({
  __name: 'DeliveryFooterCard',
  setup(__props) {

const screenWidth = computed(() => window.innerWidth)
const signatures = ref<{ signature:File, user:{ id:number, full_name:string, email:string } }[]>([])
const lastInstallmentPaid = computed(() => deliveryStore().delivery && deliveryStore().delivery.building.last_installment_paid)

const issuesFound = computed(() => {
  let issuesFound = false

  deliveryStore().delivery.rooms.forEach((r:{ survey_form: { chapters: { questions: { answer: { issues: { id:number }[] } }[] }[] }}) => {
    r.survey_form.chapters.forEach((c) => {
      c.questions.forEach((q) => {
        if (q.answer.issues.length) {
          issuesFound = true
        }
      })
    })
  })

  return issuesFound
})

const allRequiredAnswered = computed(() => {
  const allRequiredAnswered:boolean[] = []

  deliveryStore().delivery.rooms.forEach((r:{ survey_form: { chapters: { questions: { required:boolean, answer: { answer:string|null, issues: { id:number }[] } }[] }[] }}, index:number) => {
    allRequiredAnswered[index] = true
    r.survey_form.chapters.forEach((c) => {
      c.questions.forEach((q) => {
        if (q.required && q.answer.answer === null) {
          allRequiredAnswered[index] = false
        }
      })
    })
  })

  return allRequiredAnswered
})

function saveSignature (file:File, user:{ id:number, full_name:string, email:string }) : void {
  signatures.value.forEach((s:{ signature:File, user:{ id:number, full_name:string, email:string } }, index:number) => {
    if (s.user.id === user.id) {
      signatures.value.splice(index, 1)
    }
  })

  signatures.value.push({
    signature: file,
    user: {
      id: user.id,
      full_name: user.full_name,
      email: user.email
    }
  })
}

function deleteSignature (user:{ id:number, full_name:string, email:string }) : void {
  signatures.value.forEach((s:{ signature:File, user:{ id:number, full_name:string, email:string } }, index:number) => {
    if (s.user.id === user.id) {
      signatures.value.splice(index, 1)
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: "Samenvatting en ondertekenen",
    bordered: false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { span: 24 }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            xs: {span: 24},
            sm: {span: 24},
            md: {span: 24},
            lg: {span: 12}
          }, {
            default: _withCtx(() => [
              _createVNode(DeliveryDetailsRow, {
                label: "Project",
                content: _unref(deliveryStore)().delivery.building.project.name + ' (' + _unref(deliveryStore)().delivery.building.project.reference + ')'
              }, null, 8, ["content"]),
              (_unref(deliveryStore)().delivery.building)
                ? (_openBlock(), _createBlock(DeliveryDetailsRow, {
                    key: 0,
                    label: "Bouwnummer",
                    content: _unref(deliveryStore)().delivery.building.number + ' (' + _unref(deliveryStore)().delivery.building.reference + ')'
                  }, null, 8, ["content"]))
                : _createCommentVNode("", true),
              (_unref(deliveryStore)().delivery.building.customer.contractors)
                ? (_openBlock(), _createBlock(DeliveryContractorsRow, {
                    key: 1,
                    label: "De verkrijgers",
                    contractors: _unref(deliveryStore)().delivery.building.customer.contractors
                  }, null, 8, ["contractors"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, {
            xs: {span: 24},
            sm: {span: 24},
            md: {span: 24},
            lg: {span: 12}
          }, {
            default: _withCtx(() => [
              (_unref(deliveryStore)().delivery.building.project.entity)
                ? (_openBlock(), _createBlock(DeliveryEntityRow, {
                    key: 0,
                    label: "De ondernemer",
                    entity: _unref(deliveryStore)().delivery.building.project.entity
                  }, null, 8, ["entity"]))
                : _createCommentVNode("", true),
              (_unref(deliveryStore)().delivery.building)
                ? (_openBlock(), _createBlock(DeliveryDetailsRow, {
                    key: 1,
                    label: _unref(deliveryStore)().delivery.type === 'inspection' ? 'Uit te voeren door' : 'Opleverfuctionaris',
                    content: _unref(deliveryStore)().delivery.type === 'inspection' ? _unref(deliveryStore)().delivery.inspection_scheduled_user.full_name : _unref(deliveryStore)().delivery.delivery_scheduled_user.full_name
                  }, null, 8, ["label", "content"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_divider),
      (_unref(issuesFound))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_2,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(deliveryStore)().delivery.rooms, (r) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: r.id
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(r.survey_form.chapters, (c) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: c.id
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.questions, (q) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: q.id
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(q.answer.issues, (i, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: i.id
                          }, [
                            (index === 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                                  _createElementVNode("b", null, _toDisplayString(r.level) + "." + _toDisplayString(r.position) + " " + _toDisplayString(r.name) + " - " + _toDisplayString(q.name), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_4, "#" + _toDisplayString(i.id) + " - " + _toDisplayString(i.description), 1)
                          ], 64))
                        }), 128))
                      ], 64))
                    }), 128))
                  ], 64))
                }), 128))
              ], 64))
            }), 128))
          ], 64))
        : (_openBlock(), _createElementBlock("p", _hoisted_5, "Geen onvolkomenheden geconstateerd aan de woning.")),
      _createVNode(_component_a_divider),
      _createElementVNode("p", null, [
        _createTextVNode("Opgemaakt te "),
        _createElementVNode("b", null, _toDisplayString(_unref(deliveryStore)().delivery.building.address) + ", " + _toDisplayString(_unref(deliveryStore)().delivery.building.zipcode) + " " + _toDisplayString(_unref(deliveryStore)().delivery.building.city), 1),
        _createTextVNode(" op "),
        _createElementVNode("b", null, _toDisplayString(new Date().toLocaleDateString('nl-NL')), 1),
        _createTextVNode(".")
      ]),
      _createVNode(_component_a_row, {
        gutter: [32,32],
        class: "no-mb"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            xs: {span: 24},
            sm: {span: 24},
            md: {span: 24},
            lg: {span: 8}
          }, {
            default: _withCtx(() => [
              (!_unref(deliveryStore)().deliveryClosed)
                ? (_openBlock(), _createBlock(SignatureField, {
                    key: 0,
                    "return-type": "file",
                    width: "100%",
                    height: "200px",
                    signatureName: 'Oplevering_' + _unref(deliveryStore)().delivery.id + '_Handtekening_Opleverfunctionaris_' + _unref(deliveryStore)().delivery.delivery_scheduled_user.id,
                    onSignatureSave: _cache[0] || (_cache[0] = ($event: any) => (saveSignature($event, _unref(deliveryStore)().delivery.delivery_scheduled_user))),
                    onSignatureCleared: _cache[1] || (_cache[1] = ($event: any) => (deleteSignature(_unref(deliveryStore)().delivery.delivery_scheduled_user)))
                  }, null, 8, ["signatureName"]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(deliveryStore)().delivery.signatures, (s) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: s.user_id
                    }, [
                      (s.user_id === _unref(deliveryStore)().delivery.delivery_scheduled_user.id)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: s.url
                          }, null, 8, _hoisted_6))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128)),
              _createElementVNode("p", _hoisted_7, [
                _hoisted_8,
                _hoisted_9,
                _createTextVNode(" " + _toDisplayString(_unref(deliveryStore)().delivery.delivery_scheduled_user?.full_name), 1),
                _hoisted_10,
                _createTextVNode(" " + _toDisplayString(_unref(deliveryStore)().delivery.building?.project?.entity?.name), 1)
              ])
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(deliveryStore)().delivery.building.customer.contractors, (c) => {
            return (_openBlock(), _createBlock(_component_a_col, {
              xs: {span: 24},
              sm: {span: 24},
              md: {span: 24},
              lg: {span: 8},
              key: c.id
            }, {
              default: _withCtx(() => [
                (!_unref(deliveryStore)().deliveryClosed)
                  ? (_openBlock(), _createBlock(SignatureField, {
                      key: 0,
                      "return-type": "file",
                      width: "100%",
                      height: "200px",
                      signatureName: 'Oplevering_' + _unref(deliveryStore)().delivery.id + '_Handtekening_Koper_' + c.id,
                      onSignatureSave: ($event: any) => (saveSignature($event, c)),
                      onSignatureCleared: ($event: any) => (deleteSignature(c))
                    }, null, 8, ["signatureName", "onSignatureSave", "onSignatureCleared"]))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(deliveryStore)().delivery.signatures, (s) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: s.user_id
                      }, [
                        (s.user_id === c.id)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: s.url
                            }, null, 8, _hoisted_11))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128)),
                _createElementVNode("p", _hoisted_12, [
                  _hoisted_13,
                  _hoisted_14,
                  _createTextVNode(" " + _toDisplayString(c.full_name), 1),
                  _hoisted_15,
                  _createTextVNode(" " + _toDisplayString(c.email), 1)
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }),
      (!_unref(deliveryStore)().deliveryClosed && _unref(deliveryStore)().addressComplete)
        ? (_openBlock(), _createBlock(_component_a_row, {
            key: 2,
            gutter: [16,16]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_checkbox, {
                    checked: _unref(deliveryStore)().updateCustomerAddressAfterDelivery,
                    onChange: _cache[2] || (_cache[2] = ($event: any) => (_unref(deliveryStore)().updateCustomerAddressAfterDelivery = !_unref(deliveryStore)().updateCustomerAddressAfterDelivery))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Na ondertekening automatisch het correspondentie adres van de koper(s) aanpassen naar: " + _toDisplayString(_unref(deliveryStore)().delivery.building.address) + ", " + _toDisplayString(_unref(deliveryStore)().delivery.building.zipcode) + " " + _toDisplayString(_unref(deliveryStore)().delivery.building.city), 1)
                    ]),
                    _: 1
                  }, 8, ["checked"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_unref(deliveryStore)().deliveryClosed)
        ? (_openBlock(), _createBlock(_component_a_divider, { key: 3 }))
        : _createCommentVNode("", true),
      (!_unref(deliveryStore)().deliveryClosed && _unref(lastInstallmentPaid))
        ? (_openBlock(), _createBlock(_component_a_button, {
            key: 4,
            type: "primary",
            loading: _unref(deliveryStore)().loading.saving,
            disabled: !_unref(allRequiredAnswered) || !_unref(deliveryStore)().delivery.building.customer.contractors.length || signatures.value.length !== _unref(deliveryStore)().delivery.building.customer.contractors.length + 1 || _unref(deliveryStore)().loading.saving,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(deliveryStore)().completeDelivery(signatures.value)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Oplevering definitief opslaan")
            ]),
            _: 1
          }, 8, ["loading", "disabled"]))
        : _createCommentVNode("", true),
      (!_unref(deliveryStore)().deliveryClosed && !_unref(lastInstallmentPaid))
        ? (_openBlock(), _createBlock(_component_a_popconfirm, {
            key: 5,
            placement: "topLeft",
            "ok-text": "Oplevering voltooien zonder sleuteloverdracht",
            onConfirm: _cache[4] || (_cache[4] = ($event: any) => (_unref(deliveryStore)().completeDelivery(signatures.value)))
          }, {
            title: _withCtx(() => [
              _hoisted_16,
              _hoisted_17
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                loading: _unref(deliveryStore)().loading.saving,
                disabled: !_unref(allRequiredAnswered) || !_unref(deliveryStore)().delivery.building.customer.contractors.length || signatures.value.length !== _unref(deliveryStore)().delivery.building.customer.contractors.length + 1 || _unref(deliveryStore)().loading.saving
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Oplevering definitief opslaan")
                ]),
                _: 1
              }, 8, ["loading", "disabled"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})